import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuthenticatedAxios } from '../useAuthenticatedAxios';
import { toast } from '../../../components/Toast';
import { adminUserKeys } from './adminUsers.key';
import { AssignableAdminRole } from './adminUsers.types';

export function useUpdateAdminUserRoles() {
  const getAxios = useAuthenticatedAxios();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      userId,
      roles,
    }: {
      userId: string;
      roles: AssignableAdminRole[];
    }) => {
      const axios = await getAxios();
      const res = await axios.patch(
        `/api/v1/admin-users/${encodeURIComponent(userId)}/roles`,
        { roles }
      );
      return res.data;
    },
    onSuccess: () => {
      toast.success('Roller uppdaterade');
      queryClient.invalidateQueries({ queryKey: adminUserKeys.all });
    },
    onError: () => toast.error('Kunde inte uppdatera roller'),
  });
}
